import {
  MonthRecurrenceType,
  MonthWeekDayRecurrenceType,
  RecurrenceType,
  WeekDay
} from 'src/app/core/services/extended-program-guide.service';
import { DateTime } from 'luxon';
import { IRecurringEpisodeViewData } from 'src/app/core/utils/episode-details-utils';

export const weekDayToString = (w: WeekDay) => {
  switch (w) {
    case WeekDay.Monday:
      return 'Monday';
    case WeekDay.Tuesday:
      return 'Tuesday';
    case WeekDay.Wednesday:
      return 'Wednesday';
    case WeekDay.Thursday:
      return 'Thursday';
    case WeekDay.Friday:
      return 'Friday';
    case WeekDay.Saturday:
      return 'Saturday';
    case WeekDay.Sunday:
      return 'Sunday';
  }
};

export const monthlyRecurrenceOrderToString = (
  value: MonthWeekDayRecurrenceType
) => {
  switch (value) {
    case MonthWeekDayRecurrenceType.First:
      return 'first';
    case MonthWeekDayRecurrenceType.Second:
      return 'second';
    case MonthWeekDayRecurrenceType.Third:
      return 'third';
    case MonthWeekDayRecurrenceType.Fourth:
      return 'fourth';
    case MonthWeekDayRecurrenceType.Last:
      return 'last';
  }
};

export const numberToOrdinal = (n: number): string => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;

  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
};

export const formatRecurringEpisodeSchedule = (
  recurringData: IRecurringEpisodeViewData,
  startDate: Date,
  startTime: string
) => {
  const { recurrence } = recurringData;
  const slices = new Array<string>();

  const startDateObj = DateTime.fromJSDate(startDate);
  slices.push(
    `Airs on ${startDateObj.setLocale('en').toLocaleString(DateTime.DATE_FULL)}`
  );
  slices.push(`at ${startTime}.`);

  slices.push('Repeats');

  switch (recurrence.type) {
    case RecurrenceType.Day:
      slices.push(
        `every ${recurrence.repeat === 1 ? 'day' : `${recurrence.repeat} days`}`
      );
      break;
    case RecurrenceType.Week: {
      const weekDays = new Array<string>();
      for (const w of recurrence.week_days) {
        weekDays.push(weekDayToString(w));
      }
      slices.push(
        `every ${
          recurrence.repeat === 1 ? 'week' : `${recurrence.repeat} weeks`
        } ${weekDays.length ? `on ${weekDays.join(', ')}` : ''}`
      );
      break;
    }
    case RecurrenceType.Month: {
      slices.push(
        `every ${
          recurrence.repeat === 1 ? 'month' : `${recurrence.repeat} months`
        } on the`
      );
      switch (recurrence.recurrence.type) {
        case MonthRecurrenceType.Day:
          slices.push(`${numberToOrdinal(recurrence.recurrence.day)} day`);
          break;
        case MonthRecurrenceType.WeekDay:
          slices.push(
            `${monthlyRecurrenceOrderToString(
              recurrence.recurrence.order
            )} ${weekDayToString(recurrence.recurrence.week_day)}`
          );
          break;
      }
      slices.push(`of the month`);
      break;
    }
  }

  if (recurringData.end.date) {
    const endDate = DateTime.fromJSDate(recurringData.end.date);
    slices.push(
      `until ${endDate.setLocale('en').toLocaleString(DateTime.DATE_FULL)}.`
    );
  } else {
    slices.push(`indefinitely.`);
  }

  return slices.join(' ');
};
